var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayslip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 112.6,
    cy: 74.768,
    r: 3.162
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 124.32,
    cy: 87.948,
    r: 3.162
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M110.219 90.929l16.65-19.352"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M87.417 129.234v.108"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M98.777 82.666h-8.55M98.777 49.523h-8.55M94.502 53.798v-8.551M64.758 99.177h68.099"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M128.289 114.789s-.719-4.135-4.139-4.132c-3.421.003-4.336 4.139-4.336 4.139l8.889 6.727M120.229 121.532s.719 4.135 4.139 4.132c3.421-.003 4.336-4.139 4.336-4.139M124.249 107.135l.003 3.523M124.266 125.663l.003 3.523"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M128.697 46.222s-.719-4.135-4.139-4.132c-3.421.003-4.336 4.139-4.336 4.139l8.889 6.727M120.636 52.965s.719 4.135 4.139 4.132c3.421-.003 4.336-4.139 4.336-4.139M124.656 38.568l.004 3.522M124.673 57.096l.004 3.523M114.667 46.222s-.719-4.135-4.139-4.132c-3.421.003-4.336 4.139-4.336 4.139l8.889 6.727M106.607 52.965s.719 4.135 4.139 4.132c3.421-.003 4.336-4.139 4.336-4.139M110.627 38.568l.003 3.522M110.644 57.096l.003 3.523"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M113.631 114.789s-.719-4.135-4.139-4.132c-3.421.003-4.336 4.139-4.336 4.139l8.889 6.727M105.571 121.532s.719 4.135 4.139 4.132c3.421-.003 4.336-4.139 4.336-4.139M109.591 107.135l.003 3.523M109.608 125.663l.003 3.523M98.729 114.789s-.719-4.135-4.139-4.132c-3.421.003-4.336 4.139-4.336 4.139l8.889 6.727M90.669 121.532s.719 4.135 4.139 4.132c3.421-.003 4.336-4.139 4.336-4.139M94.689 107.135l.003 3.523M94.706 125.663l.003 3.523M84.071 114.789s-.719-4.135-4.139-4.132c-3.421.003-4.336 4.139-4.336 4.139l8.889 6.727M76.011 121.532s.719 4.135 4.139 4.132c3.421-.003 4.336-4.139 4.336-4.139M80.031 107.135l.003 3.523M80.048 125.663l.003 3.523"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M79.987 27.373h60.637v112.295H57.183V50.177"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M79.99 27.373L57.187 50.176H79.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayslip);
export default __webpack_public_path__ + "static/media/payslip.1d6a564387f257a07bff94cc87697374.svg";
export { ForwardRef as ReactComponent };